/* eslint-disable radix */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import appConfig from 'app-config';
// eslint-disable-next-line import/no-extraneous-dependencies
import { MetadataContent } from '@jutro/legacy/uiconfig';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ServiceManager } from '@jutro/legacy/services';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import '@xengage/gw-platform-translations';
import metadata from './MLCustomQuoteRangeSliderComponent.metadata.json5';
import messages from './MLCustomQuoteRangeSliderComponent.messages';
import styles from './MLCustomQuoteRangeSliderComponent.modules.scss';

const LEAST_INDEX = 0;
const RECOMMENDED_INDEX = 2;
const MORE_COVERAGE = 3;
const MOST_COVERAGE = 4;


function CustomRangeSlider(props) {
    CustomRangeSlider.propTypes = {
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
        indexOfSelected: PropTypes.number.isRequired,
        handleRangeChange: PropTypes.func.isRequired
    };

    const {
        min,
        max,
        indexOfSelected,
        handleRangeChange
    } = props;

    return (
        <input type="range" id="customRangeSlider" value={indexOfSelected} onChange={handleRangeChange} min={min} max={max} />
    );
}

function MLCustomQuoteRangeSliderComponent(props) {
    const translator = useTranslator();
    const localeService = ServiceManager.getService('locale-service');
    const localCurrency = localeService.getDefaultCurrencyCode();
    const isQuoteAndBuy = appConfig.portalCode === 'QB';
    const {
        quotes,
        selectedQuote,
        updateSelectedQuoteCallback
    } = props;

    const labels = [
        translator(messages.leastCoverage),
        translator(messages.lessCoverage),
        translator(messages.recommendedCoverage),
        translator(messages.moreCoverage),
        translator(messages.mostCoverage)
    ];

    const min = 0;
    const [max, setMax] = useState(0);
    const [indexOfSelected, setIndexOfSelected] = useState(0);
    const [selectedQuoteObj, setSelectedQuoteObj] = useState(selectedQuote);
    const [mobileLabel, setMobileLabel] = useState('');

    const sortQuotes = () => {
        quotes.sort((q1, q2) => {
            return q1.offeringPriority_ML - q2.offeringPriority_ML;
        });
    };

    const setLabelFor2Offerings = () => {
        quotes[0].label = quotes[0].branchName;
        quotes[1].label = quotes[1].branchName;
    };

    const setLabelFor3Offerings = () => {
        quotes[0].label = quotes[0].branchName;
        quotes[1].label = quotes[1].branchName;
        quotes[2].label = quotes[2].branchName;
    };

    const setLabelFor4Offerings = () => {
        quotes[0].label = quotes[0].branchName;
        quotes[1].label = quotes[1].branchName;
        quotes[2].label = quotes[2].branchName;
        quotes[3].label = quotes[3].branchName;
    };

    const setLabelFor5Offerings = () => {
        // eslint-disable-next-line no-return-assign
        quotes.forEach((q, index) => q.label = labels[index]);
    };

    const setLabels = () => {
        if (quotes.length === 1) {
            quotes[0].label = quotes[0].branchName;
        } else if (quotes.length === 2) {
            setLabelFor2Offerings();
        } else if (quotes.length === 3) {
            setLabelFor3Offerings();
        } else if (quotes.length === 4) {
            setLabelFor4Offerings();
        } else if (quotes.length === 5) {
            setLabelFor5Offerings();
        } else {
            // eslint-disable-next-line no-console
            console.error(new Error('Unknown length of offerings'));
        }
    };

    const cleanlabel = () => {
        if (selectedQuoteObj && selectedQuoteObj.label) {
            setMobileLabel(selectedQuoteObj.label.replace('<br>', ' '));
        }
    };

    const onChangeValue = (index) => {
        const newQuote = quotes[index];
        setSelectedQuoteObj(newQuote);        
        updateSelectedQuoteCallback(newQuote);
    };

    useEffect(()=>{
        cleanlabel();
    },[cleanlabel, selectedQuoteObj])

    const handleRangeChange = (e) => {
        const index = parseInt(_.get(e, 'target.value', 0));
        setIndexOfSelected(index);
        onChangeValue(index);
    };

    const mobileSelectQuote = (value) => {
        const currentValue = indexOfSelected + value;

        if ((currentValue >= min) && (currentValue <= max)) {
            setIndexOfSelected(currentValue);
            onChangeValue(currentValue);
        }
    };

    const onMobileSelectQuotePlus = () => {
        mobileSelectQuote(1);
    };

    const onMobileSelectQuoteMinus = () => {
        mobileSelectQuote(-1);
    };

    const getCurrentPercentage = useCallback(() => {
        const inputRange = document.getElementById('customRangeSlider');

        const inputMin = parseInt(_.get(inputRange, 'attributes.min.value', 0));
        const inputMax = parseInt(_.get(inputRange, 'attributes.max.value', 0));

        return ((indexOfSelected - inputMin) * 100) / (inputMax - inputMin);
    }, [indexOfSelected]);

    useEffect(() => {
        setMax(quotes.length - 1);
        sortQuotes();
        let index = 0;
        if (selectedQuote.isCustom) {
            index = quotes.findIndex((q) => q.branchCode === selectedQuote.branchCode);
        } else {
            index = quotes.findIndex((q) => q.publicID === selectedQuote.publicID);
        }
        setIndexOfSelected(index);
        if (isQuoteAndBuy) {
            setSelectedQuoteObj(quotes[index]);
        } else {
            setSelectedQuoteObj(quotes[indexOfSelected]);
        }
        setLabels();
        cleanlabel();

        const initialPercentage = getCurrentPercentage();
        const premiumTracker = document.getElementById('rangeSliderPremiumInfo');
        if (!_.isNaN(initialPercentage)) {
            premiumTracker.style.left = `${initialPercentage}%`;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const premiumTracker = document.getElementById('rangeSliderPremiumInfo');

        const currentPercentage = getCurrentPercentage();
        if (!_.isNaN(currentPercentage)) {
            premiumTracker.style.left = `${currentPercentage}%`;
        }
    }, [indexOfSelected, getCurrentPercentage]);


    const resolvers = {
        resolveComponentMap: {
            customRangeSlider: CustomRangeSlider
        },
        resolveCallbackMap: {
            onMobileSelectQuotePlus,
            onMobileSelectQuoteMinus
        },
        resolveClassnameMap: styles
    };

    const getCurrencySymbol = () => {
        const selectedQuotePremiumCurrency = _.get(selectedQuoteObj, 'premium.monthlyPremium.currency', undefined);

        return !_.isUndefined(selectedQuotePremiumCurrency)
            ? localeService.getCurrencySymbol(selectedQuotePremiumCurrency)
            : localeService.getCurrencySymbol(localCurrency);
    };

    const getLiOverrides = useCallback(() => {
        const liOverrides = quotes.map((quote, index) => {
            return {
                [`rangeSliderLi${index}`]: { className: index === indexOfSelected ? 'ml-range-slider__tick-group-tick active' : 'ml-range-slider__tick-group-tick' }
            };
        });
        return Object.assign({}, ...liOverrides);
    }, [quotes, indexOfSelected]);

    const overrides = {
        rangeSliderUL: {
            data: quotes
        },
        customRangeSlider: {
            min: min,
            max: max,
            indexOfSelected: indexOfSelected,
            handleRangeChange: handleRangeChange
        },
        rangePremiumAmount: {
            content: _.get(selectedQuoteObj, 'premium.monthlyPremium.amount', 0)
        },
        rangePremiumSymbol: {
            content: getCurrencySymbol(),
            className: (isQuoteAndBuy && indexOfSelected === min) ? 'symbol symbolSup': 'symbol sup'
        },
        rangePremiumMonthly: {
            className: (isQuoteAndBuy && indexOfSelected === max) ? 'monthly monthlySup': 'monthly'
        },
        currencySup: {
            content: getCurrencySymbol()
        },
        monthlyPremium: {
            content: _.get(selectedQuoteObj, 'premium.monthlyPremium.amount', 0)
        },
        customCovsHeader: {
            content: mobileLabel
        },
        minusBtn: {
            className: indexOfSelected === min ? 'minus-btn disabled' : 'minus-btn'
        },
        addBtn: {
            className: indexOfSelected === max ? 'add-btn disabled' : 'add-btn'
        },
        ...getLiOverrides()
    };


    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLCustomQuoteRangeSliderComponent.propTypes = {
    quotes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectedQuote: PropTypes.shape({}).isRequired,
    updateSelectedQuoteCallback: PropTypes.func.isRequired
};

export default MLCustomQuoteRangeSliderComponent;
